export default class Notification {
    constructor(show = false, content = 'Some Content') {
        this.id = Math.random().toString(36).substring(2, 15);
        this.show = show;
        this.content = content;
    }
}
